import { useExperimentBucket } from '@carvana/experiment';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { Experiments } from '~/contracts/common';

export default function useTrackRendered(
  experimentName: keyof Experiments,
  condition: boolean = true,
  customAttributes: any = {},
  bucketOverride?: string
) {
  const providerBucket = useExperimentBucket(experimentName);
  const experimentBucket = bucketOverride ?? providerBucket;
  const trackEvent = useTrackEvent();

  useEffectOnce(
    () => {
      const eventName = `${experimentName} ${experimentBucket} rendered`;

      trackEvent(eventName, customAttributes);
      datadogRum.addAction(eventName, customAttributes);
    },
    [customAttributes, experimentBucket, experimentName, trackEvent],
    condition && Boolean(experimentBucket)
  );
}
